import React from 'react';
import { useState } from 'react';
import { createUseStyles } from 'react-jss';
import variables from '../../theme/variables';
import classNames from 'classnames';

const useStyles = createUseStyles(
    {
        btn: {
            background: 'rgba(0, 0, 0, 0.16)',
            border: '1px solid #CCCCCC',
            backdropFilter: 'blur(10px)',
            borderRadius: 8,
            border: `1px solid ${variables.palette.black}`,
            color: variables.palette.black,
            textAlign: 'center',
            fontSize: 18,
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            padding: '0 24px',
            height: 52,
            cursor: 'pointer',
            // transition: 'all 0.2s ease-in-out',

            '@media (min-width: 1024px)': {
                padding: '0 32px',
            },

            '& svg': {
                marginRight: 8,
            },

            '&:not(:last-of-type)': {
                marginRight: 5,

                '@media (min-width: 1024px)': {
                    marginRight: 20,
                },
            },
        },

        checked: {
            background: variables.palette.black,
            color: variables.palette.white,
        },

        input: {
            display: 'none',
        },
    },
    { name: 'CheckButton' }
);

export default function CheckButton({ id, text, onChange }) {
    const classes = useStyles();

    const [checked, setChecked] = useState(false);

    const handleChange = (e) => {
        const checked = e.target.checked;
        setChecked(checked);
        onChange(checked);
    };

    return (
        <label
            htmlFor={id}
            className={classNames(classes.btn, checked ? classes.checked : '')}
        >
            <input
                type="checkbox"
                id={id}
                onChange={handleChange}
                className={classes.input}
            />
            {text}
        </label>
    );
}
